import Image from 'next/image';
import type { FC } from 'react';
import { Chip, Container } from '@/DesignSystem/Component';
import CommentRegister from '@/Module/Comment/Component/CommentRegister/CommentRegister';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
const CommentRegisterWrapper: FC = () => {
  return <div className="border-l-8 border-r-4 border-t-8 border-blueFive bg-orangeThree bg-comment-register" data-sentry-component="CommentRegisterWrapper" data-sentry-source-file="CommentRegisterWrapper.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="CommentRegisterWrapper.tsx">
        <Chip title="نظر کاربران" color="tertiary" className="mt-6 sm:mt-16" data-sentry-element="Chip" data-sentry-source-file="CommentRegisterWrapper.tsx" />
        <h5 className="my-6 text-2xl font-bold text-orangeSix  drop-shadow-errorText sm:my-10 sm:text-4xl lg:text-5xl">
          نظر شما چیست؟
        </h5>
        <div className="flex flex-col items-center justify-between md:flex-row md:items-end ">
          <CommentRegister data-sentry-element="CommentRegister" data-sentry-source-file="CommentRegisterWrapper.tsx" />
          <Image src={`${FILE_BROWSER_URL}/img/girl.webp`} alt="girl" className=" w-auto md:max-w-[50%]" width={589} height={590} data-sentry-element="Image" data-sentry-source-file="CommentRegisterWrapper.tsx" />
        </div>
      </Container>
    </div>;
};
export default CommentRegisterWrapper;